import React, { useState, useEffect } from 'react';
import i18n from 'i18next';
import { connect } from 'react-redux';
import userManager from './../../utils/userManager';

const AsideMenu = ({ openSideBar, closeSideBar, t, user }) => {
  const [pageLanguage, setPageLanguage] = useState('en');
  const [userProfile, setUserProfile] = useState(null);

  const supportedLanguages = [
    {
      val: 'bg',
      label: 'Bulgarian',
    },
    {
      val: 'cs',
      label: 'Czech',
    },
    {
      val: 'da',
      label: 'Danish',
    },
    {
      val: 'de',
      label: 'German',
    },
    {
      val: 'de-CH',
      label: 'Swiss German',
    },
    {
      val: 'en',
      label: 'English',
    },
    {
      val: 'es',
      label: 'Spanish',
    },
    {
      val: 'et',
      label: 'Estonian',
    },
    {
      val: 'fi',
      label: 'Finnish',
    },
    {
      val: 'fr',
      label: 'French',
    },
    {
      val: 'hu',
      label: 'Hungarian',
    },
    {
      val: 'it',
      label: 'Italian',
    },
    {
      val: 'lv',
      label: 'Latvian',
    },
    {
      val: 'no',
      label: 'Norwegian',
    },
    {
      val: 'pt',
      label: 'Portuguese',
    },
    {
      val: 'ro',
      label: 'Romanian',
    },
    {
      val: 'sv',
      label: 'Swedish',
    },
    {
      val: 'tr',
      label: 'Turkish',
    },
  ];

  useEffect(() => {
    const { language } = i18n;
    setPageLanguage(language);
  }, []);

  useEffect(() => {
    if (!user) return;

    setUserProfile(user.profile.name);
  }, [user]);

  const changeLangauge = lang => {
    setPageLanguage(lang);
    i18n.changeLanguage(lang);
  };

  const logoutUser = () => {
    userManager.removeUser();
  };

  return (
    <aside className={`sidebar${openSideBar ? ' sidebar--open' : ''}`}>
      <div
        className="sidebar__menu"
        onClick={() => {
          closeSideBar(false);
        }}
      >
        <span />
        <span />
      </div>
      <div className="sidebar__content">
        <div className="sidebar__item">
          <label>{t('language')}</label>
          <div className="sidebar__languages">
            {supportedLanguages.map(lang => {
              return (
                <div
                  className={`sidebar__languages-option${
                    pageLanguage === lang.val
                      ? ' sidebar__languages-option--active'
                      : ''
                  }`}
                  key={lang.val}
                  onClick={() => {
                    changeLangauge(lang.val);
                  }}
                >
                  {lang.label}
                </div>
              );
            })}
          </div>
        </div>
        {userProfile && (
          <div className="sidebar__item" onClick={logoutUser}>
            <label>{userProfile}</label>
            <div className="sidebar__signout">{t('signout')}</div>
          </div>
        )}
      </div>
    </aside>
  );
};

const mapStateToProps = ({ oidc }) => ({ user: oidc.user });

export default connect(mapStateToProps)(AsideMenu);
